<template lang="pug">
  .div
    .columns.is-vcentered
      .column.is-2
        label.label Fecha
            .field
              .control
                flat-pickr(
                  v-model='fecha'
                  :config="config"
                  class="input"
                )
      .column.is-2
        .field
          label.label Destino
          .control.has-icons-left
            .select.is-primary.is-rounded
              select(v-model="ubicacionSel" :disabled="isDisabled")
                option(v-for="ubi in ubicaciones" :key="ubi.valor" :value="ubi") {{ ubi.nombre }}
            .icon.is-small.is-left
              i.fas.fa-map-pin
      .column.is-2
        .field
          label.label {{ isSalida ? 'Almacén' : 'Oficina'}}
          .control.has-icons-left
            .select.is-primary.is-rounded
              select(v-model="oficinaSelected" :disabled="isDisabled")
                option(v-for="data in oficinasSel" :value="data" :key="data.id") {{ data.oficina }}
            .icon.is-small.is-left
              i.fas.fa-tools
      .column.is-3(v-show="isSalida")
        .field
            label.label Usuario Transporta
            .control
              Typeahead#type_usuarios(:options="usuarios" :desahabilitar="isDisabled" :optionSelect="usuarioData_Transp" v-model="usuario_Transporta" )
      .column.is-3
        .field
            label.label Usuario a Entregar
            .control
              Typeahead#type_usuarios(:options="usuarios" :desahabilitar="isDisabled" :optionSelect="usuarioData_Entrega" v-model="usuario_Entregar")
    .columns(v-show="Object.keys(datosFaltantes).length > 0")
      .column.is-12
        .notification
          .field.is-grouped.is-grouped-multiline
            .control(v-for="datosF in datosFaltantes")
              .tags
                span.tag.is-danger.is-light {{ datosF }}
    .columns.has-text-centered
      .column.is-offset-4.is-2
        a.button.is-rounded(@click="cancel")
          | Cancelar Edición
      .column.is-2
        a.button.is-black.is-rounded(@click="checkForm")
          | Guardar Formulario
</template>

<script>
  import Typeahead from './Typeahead.vue'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import moment from 'moment'
  export default {
    name: 'FormCons_Salida',
    components: { Typeahead, flatPickr },
    props: {
      usuarios: {
        type: Array,
        default: []
      },
      ubicaciones: {
        type: Array,
        default: []
      },
      oficinas: {
        type: Array,
        default: []
      },
      isSalida: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        oficinasSel: [],
        usuarioData_Transp: {},
        usuarioData_Entrega: {},
        usuario_Transporta: {},
        usuario_Entregar: {},
        ubicacionSel: null,
        oficinaSelected: null,
        datosFaltantes: [],
        isDisabled: false,
        fecha: moment().format('YYYY-MM-DD'),
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only          
        },
      }
    },
    watch: {
      ubicacionSel() {
        this.oficinasSel = this.oficinas.filter( alm => alm.id_ubicacion === this.ubicacionSel.id)
      }
    },
    methods: {
      checkForm () {
        console.log('checkForm')
        this.datosFaltantes = []
        if (this.isSalida) {
          if (Object.keys(this.usuario_Transporta).length > 0 && Object.keys(this.usuario_Entregar).length > 0 && this.ubicacionSel && this.oficinaSelected) {
            this.saveForm()
          } else {
            if(Object.keys(this.usuario_Transporta).length == 0) {
              this.datosFaltantes.push('El Usuario que transporta es requerido.')
            }
            if(Object.keys(this.usuario_Entregar).length == 0) {
              this.datosFaltantes.push('El Usuario a entregar es requerido.')
            }
            if (!this.ubicacionSel) {
              this.datosFaltantes.push('La ubicación es requerida.')
            }
            if (!this.oficinaSelected) {
              this.datosFaltantes.push('El almacén es requerida.')
            }
          }
        } else {
          if (Object.keys(this.usuario_Entregar).length > 0 && this.ubicacionSel && this.oficinaSelected) {
            this.saveForm()
          } else {
            if(Object.keys(this.usuario_Entregar).length == 0) {
              this.datosFaltantes.push('El Usuario a entregar es requerido.')
            }
            if (!this.ubicacionSel) {
              this.datosFaltantes.push('La ubicación es requerida.')
            }
            if (!this.oficinaSelected) {
              this.datosFaltantes.push('El almacén es requerida.')
            }
          }
        }
      },
      saveForm () {
        let myObj = {}
        if (this.isSalida) {
          myObj = {
            idUsuario_Transporta: this.usuario_Transporta.id,
            usuario_Transporta: this.usuario_Transporta.nombre,
            idUsuario_Entregar: this.usuario_Entregar.id,
            usuario_Entregar: this.usuario_Entregar.nombre,
            ubicacion: this.ubicacionSel,
            oficina: this.oficinaSelected,
            fecha: this.fecha,
          }
        } else {
          myObj = {
            idUsuario_Entregar: this.usuario_Entregar.id,
            usuario_Entregar: this.usuario_Entregar.nombre,
            ubicacion: this.ubicacionSel,
            oficina: this.oficinaSelected,
            fecha: this.fecha,
          }
        }
        this.isDisabled = true
        this.$emit('saveForm', myObj)
      },
      cancel () {
        this.isDisabled = false
      }
    },  
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/FormCons_Salida.vue